
export const MixinProductLabels = {
  computed: {
    productLabel() {
			// TODO: add check for "new" attribute

			if (this.product.tags) {
				const labels = [
					{key: 'choice-new', value: 'new'},
					{key: 'choice-plant-based', value: 'plantbased'},
					{key: 'choice-vegan', value: 'vegan'},
					{key: 'choice-vegi', value: 'vegi'},
					{key: 'choice-vegetarian', value: 'vegi'},
				];

				for (let label of labels) {
					if (this.product.tags.includes(label.key)) {
						return productLabelPath(label.value);
					}
				}
			}

      return false;
    }
  },
	methods: {
		productLabelPath(attr) {
			return `/files/${this.themeName}/images/attr-${attr}.svg`;
		}
	}
};

export default MixinProductLabels;
